export const NAMESPACE = "sb";
export const BREAKPOINTS = {
  xs: 640,
  sm: 768,
  md: Infinity,
} as const;
